var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("path",{"id":"ic_close_svg__a","d":"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z","key":0}),React.createElement("path",{"id":"ic_close_svg__c","d":"M0 0h50v50H0z","key":1})]),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"ic_close_svg__b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#ic_close_svg__a"})),React.createElement("g",{"mask":"url(#ic_close_svg__b)","key":1},React.createElement("use",{"fill":"#000","xlinkHref":"#ic_close_svg__c","transform":"translate(-13 -13)"}))])]);
}

Close.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/close.svg
// module id = 1473
// module chunks = 0